module.exports = __webpack_public_path__ + "img/full2-min.95f554be.png";